import { render, staticRenderFns } from "./DedicatedService.vue?vue&type=template&id=32e4e0e8&"
import script from "./DedicatedService.vue?vue&type=script&lang=js&"
export * from "./DedicatedService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32e4e0e8')) {
      api.createRecord('32e4e0e8', component.options)
    } else {
      api.reload('32e4e0e8', component.options)
    }
    module.hot.accept("./DedicatedService.vue?vue&type=template&id=32e4e0e8&", function () {
      api.rerender('32e4e0e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Dedicated/DedicatedService.vue"
export default component.exports